import { strings as stringManager } from '@ps/payscale-shared-ui/lib/Strings'; // string manager singleton

// define namespace for module strings
export const moduleName = 'usermanagement';
interface ModuleStrings {
    add: string;
    addUser: string;
    addUsersFromFile: string;
    browse: string;
    bulkUploadFile: string;
    cancel: string;
    continue: string;
    deleteInvite: string;
    deleteInviteFailureMsg: string;
    deleteInviteFailureTitle: string;
    deleteInviteSuccessMsg: string;
    deleteInviteSuccessTitle: string;
    deleteUser: string;
    deleteUserConfirmMessage: string;
    deleteUserFailureMsg: string;
    deleteUserFailureTitle: string;
    deleteUserSuccessMsg: string;
    deleteUserSuccessTitle: string;
    downloadUsers: string;
    dropFile: string;
    edit: string;
    editUser: string;
    editUserFailureMsg: string;
    editUserFailureTitle: string;
    editUserSuccessMsg: string;
    editUserSuccessTitle: string;
    invalidFileMsg: string;
    inviteUserFailureMsg: string;
    inviteUserFailureTitle: string;
    inviteUserSuccessMsg: string;
    inviteUserSuccessTitle: string;
    inviteUsersFailureMsg: string;
    inviteUsersFailureTitle: string;
    inviteUsersSuccessMsg: string;
    inviteUsersSuccessTitle: string;
    lastLoginUnknown: string;
    locked: string;
    logoutButton: string;
    passwordResetFailureMsg: string;
    passwordResetFailureTitle: string;
    passwordResetSuccessMsg: string;
    passwordResetSuccessTitle: string;
    registerUserFailureMsg: string;
    registerUserFailureTitle: string;
    registerUserSuccessMsg: string;
    registerUserSuccessTitle: string;
    registerUsersFailureMsg: string;
    registerUsersFailureTitle: string;
    registerUsersSuccessMsg: string;
    registerUsersSuccessTitle: string;
    resetPassword: string;
    samlControlledAccount: string;
    save: string;
    searchUsers: string;
    sendEmail: string;
    sendLater: string;
    sendNow: string;
    switchAccount: string;
    switchAccountsSubTitle: string;
    switchAccountsTitle: string;
    tableHeaderLastLogin: string;
    tableHeaderRole: string;
    tableHeaderUser: string;
    totalUserCount: string;
    unlockUser: string;
    unlockUserFailureTitle: string;
    unlockUserFailureMsg: string;
    unlockUserSuccessTitle: string;
    unlockUserSuccessMsg: string;
    userDetailsFirstName: string;
    userDetailsLastName: string;
    userDetailsEmail: string;
    userDetailsRole: string;
    userManagement: string;
    userRoleAdmin: string;
    userRoleRegular: string;
}

// Load strings into string manager, enforcing the type
// (all strings defined, no new ones)
stringManager.load(moduleName, <ModuleStrings> {
    add: 'Add',
    addUser: 'Add User',
    addUsersFromFile: 'Add Users From File',
    browse: 'Browse',
    bulkUploadFile: '{0} ({1} users)',
    cancel: 'Cancel',
    continue: 'Continue',
    deleteInvite: 'Delete Invite',
    deleteInviteFailureMsg: 'An error occured deleting the invite for {0}',
    deleteInviteFailureTitle: 'Failure',
    deleteInviteSuccessMsg: 'The invite for {0} has been removed',
    deleteInviteSuccessTitle: 'User Invite Deleted',
    deleteUser: 'Delete User',
    deleteUserConfirmMessage: 'Are you sure you want to delete the account {0}?',
    deleteUserFailureMsg: 'An error occured removing the account for {0}',
    deleteUserFailureTitle: 'Failure',
    deleteUserSuccessMsg: 'The account for {0} has been removed',
    deleteUserSuccessTitle: 'User Account Deleted',
    downloadUsers: 'Download Users',
    dropFile: 'Drop your .csv file here, or click to browse',
    edit: 'Edit',
    editUser: 'Edit User',
    editUserFailureMsg: 'Failed to update account settings for {0}',
    editUserFailureTitle: 'Failure',
    editUserSuccessMsg: 'The details for {0} have been saved',
    editUserSuccessTitle: 'Details Updated',
    invalidFileMsg: 'Sorry, a properly formatted .csv file is required',
    inviteUserFailureMsg: 'An error occurred when inviting {0} to create an account',
    inviteUserFailureTitle: 'Failure',
    inviteUserSuccessMsg: 'An email has been sent inviting {0} to create an account',
    inviteUserSuccessTitle: 'Account Invite Sent',
    inviteUsersFailureMsg: 'Failed to send {0} of {1} account invites',
    inviteUsersFailureTitle: 'Failure',
    inviteUsersSuccessMsg: 'Successfully invited {0} users to create an account',
    inviteUsersSuccessTitle: 'Account Invites Sent',
    lastLoginUnknown: 'Unknown',
    locked: 'LOCKED',
    logoutButton: 'Log Out',
    passwordResetFailureMsg: 'Failed to reset password for {0}',
    passwordResetFailureTitle: 'Failure',
    passwordResetSuccessMsg: 'An email with a reset password link has been sent to {0}',
    passwordResetSuccessTitle: 'Password Reset Sent',
    registerUserFailureMsg: 'An error occurred when registering {0} to the account',
    registerUserFailureTitle: 'Failure',
    registerUserSuccessMsg: '{0} has been registered to the account',
    registerUserSuccessTitle: 'Account Registration Successful',
    registerUsersFailureMsg: 'Failed to register {0} of {1} users',
    registerUsersFailureTitle: 'Failure',
    registerUsersSuccessMsg: 'Successfully registered {0} users to the account',
    registerUsersSuccessTitle: 'Account Registrations Successful',
    resetPassword: 'Reset Password',
    samlControlledAccount: 'This account is managed via SAML',
    save: 'Save',
    searchUsers: 'Search Users',
    sendEmail: 'Send Invite Email',
    sendLater: 'Later',
    sendNow: 'Now',
    switchAccount: 'Switch Account',
    switchAccountsSubTitle: 'Select an account below to view users',
    switchAccountsTitle: 'Switch Accounts',
    tableHeaderLastLogin: 'Last Login',
    tableHeaderRole: 'Role',
    tableHeaderUser: 'User',
    totalUserCount: '{0} Total Users',
    unlockUser: 'Unlock User',
    unlockUserFailureTitle: 'Unable to Unlock Account',
    unlockUserFailureMsg: 'Unable to unlock account for {0}',
    unlockUserSuccessTitle: 'User Account Unlocked',
    unlockUserSuccessMsg: 'Account unlocked for {0}',
    userDetailsFirstName: 'First Name',
    userDetailsLastName: 'Last Name',
    userDetailsEmail: 'Email',
    userDetailsRole: 'Role',
    userManagement: 'User Management',
    userRoleAdmin: 'Administrator',
    userRoleRegular: 'Regular'
});

// export just this modules strings as a typed object, such that
// values can be referenced via 'strings.manager'
const moduleStrings = stringManager[moduleName] as ModuleStrings;
export { moduleStrings as strings };
export default moduleStrings;



// WEBPACK FOOTER //
// ./src/utils/strings.ts